import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { manager, teamAdmin } from '../../constants/appConstants';
import { manageSettlementsLoader } from '../loaders/manageSettlements';
import PageLoader from '../loaders/pageLoader';
import { rootLoader } from '../loaders/rootLoader';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../Root';

const ManageSettlementsPage = lazy(() => import('../../components/pages/manageSettlements'));

const manageSettlementsPath = '/teams' as const;

export const teamsManageSettlements = {
	path: manageSettlementsPath,
	element: <Outlet />,
	children: [
		{
			path: ':teamId/manage-settlements',
			element: (
				<ProtectedRoute allowedRoles={[teamAdmin, manager]}>
					<Suspense fallback={<PageLoader />}>
						<ManageSettlementsPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, settlementsData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					manageSettlementsLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...settlementsData,
				};
			},
		},
	],
};
